import { api } from "./index";

export interface AdminVendor {
  id: string;
  email: string;
  businessName: string | null;
  businessType: "SOLE_PROPRIETOR" | "COMPANY" | "PARTNERSHIP" | null;
  registrationNumber: string | null;
  taxId: string | null;
  address: string | null;
  phone: string | null;
  status: "REGISTERED" | "PENDING" | "ACTIVE" | "SUSPENDED";
  rejectionComment: string | null;
  emailVerified: boolean;
  createdAt: string;
  updatedAt: string;
  documents?: AdminVendorDocument[];
  _count?: {
    documents: number;
    tenderRegistrations: number;
    bidSubmissions: number;
  };
}

export interface AdminVendorDocument {
  id: string;
  vendorId: string;
  documentType: "BUSINESS_REGISTRATION" | "COMPANY_PROFILE" | "TAX_CLEARANCE" | "INSURANCE" | "FINANCIAL_STATEMENT" | "OTHER";
  fileName: string;
  fileSize: number;
  mimeType: string;
  bucket: string;
  objectKey: string;
  uploadedAt: string;
  updatedAt: string;
}

export interface UpdateVendorStatusDto {
  status: "REGISTERED" | "PENDING" | "ACTIVE" | "SUSPENDED";
  rejectionComment?: string;
}

export const adminVendorsApi = {
  listVendors: (params?: {
    status?: "REGISTERED" | "PENDING" | "ACTIVE" | "SUSPENDED";
    search?: string;
  }): Promise<AdminVendor[]> => {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append("status", params.status);
    if (params?.search) queryParams.append("search", params.search);
    const query = queryParams.toString();
    return api.get(`/vendors${query ? `?${query}` : ""}`).then((res) => res.data);
  },

  getVendor: (vendorId: string): Promise<AdminVendor> =>
    api.get(`/vendors/${vendorId}`).then((res) => res.data),

  updateVendorStatus: (
    vendorId: string,
    data: UpdateVendorStatusDto
  ): Promise<{ vendor: AdminVendor; message: string }> =>
    api.patch(`/vendors/${vendorId}/status`, data).then((res) => res.data),

  downloadDocument: async (vendorId: string, documentId: string): Promise<Blob> => {
    const response = await api.get(`/vendors/${vendorId}/documents/${documentId}/download`, {
      responseType: 'blob',
    });
    return response.data;
  },
};

